import { createEvent, createStore } from "effector";
import { useUnit } from "effector-react";
import { useEffect, useRef } from "react";

/**
 * Fired after a mutation changed a tournament (opt-in, claim prize). Every
 * mounted tournament query refetches through `useOnTournamentsChanged`, which
 * replaces the refetches Apollo ran after those mutations.
 */
export const tournamentsChanged = createEvent();

const tournamentsVersion = createStore(0).on(
  tournamentsChanged,
  (version) => version + 1,
);

const useOnTournamentsChanged = (onChange: () => void) => {
  const version = useUnit(tournamentsVersion);
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;
  const seenVersion = useRef(version);

  useEffect(() => {
    if (version === seenVersion.current) {
      return;
    }
    seenVersion.current = version;
    onChangeRef.current();
  }, [version]);
};

export default useOnTournamentsChanged;
